import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBackground from '../../images/backgrounds/general-error.png';
import styles from './generalError.module.scss';

export default memo(function GeneralError(props) {
    const [t] = useTranslation('common');

    return (
        <div className={styles.container}>
            <div className={styles.detail}>
                <img alt="Error" src={ErrorBackground} height={230} width="auto" />
                <span>{t(`common:${props.menu}`)} {t('common:not_available')}</span>
                <span>{t(`common:${props.message}`)}</span>
            </div>
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.message === nextProps.message &&
        prevProps.menu === nextProps.menu
);
